import { render } from "./ProductsFilters.vue?vue&type=template&id=11f12984"
import script from "./ProductsFilters.vue?vue&type=script&lang=js"
export * from "./ProductsFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/ProductsFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11f12984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11f12984', __exports__)) {
    api.reload('11f12984', __exports__)
  }
  
  module.hot.accept("./ProductsFilters.vue?vue&type=template&id=11f12984", () => {
    api.rerender('11f12984', render)
  })

}


export default __exports__